import React from "react";
import Shop from "./Shop";

const ShopContainer = () => {
    return (
        <>
            <Shop />
        </>
    );
};

export default ShopContainer;
